<template>
	<section class="content">
		<div class="card">
			<div class="overlay" v-if="loading"><h1 style="font-size:40px;">Sedang diproses <i class="fas fa-sync-alt fa-spin"></i></h1></div>
			<div class="card-body">
				<div v-if="infoDownload" class="form-control bos-alert-primary lh-1 d-flex align-items-center h-100" style="margin-bottom: 15px;">
					<div class="row">
						<div class="col-auto d-flex align-items-center">
							<i class="fi fi-rr-info d-flex align-items-center"></i>
						</div>
						<div class="col d-flex align-items-center">
							<div class="text-md">
								Semua file yang Anda unduh akan tersimpan dan dapat dilihat di <a href="/data-center" class="text-info" style="text-decoration: underline;">menu data center</a>
							</div>
						</div>
					</div>
				</div>
				<div class="row mb-3" style="row-gap: .5rem;">
					<div class="col-12 col-sm-auto">
						<div class="input-group">
							<input type="text" ref="daterange" class="form-control border-right-0" style="border-right: 0" />
							<div class="input-group-append">
								<div class="input-group-text rounded-right d-flex align-items-center border-left-0 pl-1 bg-white">
									<i class="fi fi-rr-calendar d-flex"></i>
								</div>
							</div>
						</div>
					</div>
					<div class="col col-sm-auto text-right ml-auto">
						<div class="btn-group" ref="toolbar">
							<button type="button" data-action="read" class="btn btn-outline-primary" v-on:click="showTable">
								Show Table
							</button>
							<button type="button" :disabled="loading" v-on:click="downloadXlsx" data-action="export-xlsx" class="btn btn-primary">
								Download Data
							</button>
						</div>
					</div>
				</div>

				<div class="table-responsive" :hidden="hideTable">
					<table class="table table-hover row-border" ref="tableMonitoringHutangCOD" id="tableMonitoringHutangCOD">
						<thead>
							<tr>
								<th>Tanggal Jurnal</th>
								<th>Referensi</th>
								<th>Status</th>
								<th>Klaim</th>
								<th>Kurir</th>
								<th>Hutang COD</th>
								<th>Credit Awal</th>
								<th>Total Credit</th>
								<th>Total Debit</th>
								<th>Sisa Hutang</th>
							</tr>
						</thead>
						<tbody>
						</tbody>
						<tfoot>
							<tr>
								<th></th>
								<th></th>
								<th></th>
								<th></th>
								<th></th>
								<th></th>
								<th></th>
								<th></th>
								<th></th>
								<th></th>
							</tr>
						</tfoot>
					</table>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
import { auth, authFetch, createTable, formatRupiah } from "@/libs/hxcore";
import $ from "jquery";
import moment from "moment";
import Swal from "sweetalert2";
import "vue-select/dist/vue-select.css";
import Daterangepicker from "daterangepicker";
import "daterangepicker/daterangepicker.css";

export default {
	name: "MonitoringHutangCOD",
	data() {
		return {
			loading: false,
			hideTable: true,
			tableMonitoringHutangCOD: null,
			infoDownload: false,
			filter: {
				dt1: moment().startOf('month').format("YYYY-MM-DD"),
				dt2: moment().format("YYYY-MM-DD"),
				keyword: null,
				category: 0,
			}
		};
	},
	created() {
		var self = this;

		authFetch("/report/hutang/cutoff/cod")
		.then((res) => {
			if (res.status === 201) {} else if (res.status === 400) {}
			return res.json();
		})
		.then((js) => {
			if (js.success) {
				new Daterangepicker(this.$refs.daterange, {
					startDate: moment().startOf('month'),
					endDate: moment(),
					minDate: moment(js.data, 'YYYY-MM-DD').format("DD/MM/YYYY"),
					maxDate: moment().format("DD/MM/YYYY"),
					locale: {
						format: 'DD/MM/YYYY'
					},
				}, function(d1, d2) {
					self.filter.dt1 = d1.format("YYYY-MM-DD");
					self.filter.dt2 = d2.format("YYYY-MM-DD");
					if (self.dataTable) { self.dataTable.api().ajax.reload(); }
				});
			} else {
				this.customSwal.fire({
					icon: "error",
					title: "Gagal",
					text: js.message,
					confirmButtonText: "OK"
				});
			}
		});
	},
	methods: {
		formatRupiah(value) {
			return formatRupiah(value);
		},
		showTable: function () {
			if (this.dataTable) {
				this.dataTable.api().ajax.reload();
			} else {
				var self = this;
				this.dataTable = createTable(this.$refs.tableMonitoringHutangCOD, {
					roles: this.$route.params.roles,
					ajax: "/report/hutang/monitoring_cod/",
					frame: false,
					toolbarEl: this.$refs.toolbar,
					fixedColumns: {
						start: 1,
						end: 1
					},
					scrollCollapse: true,
					scrollX: true,
					processing: true,
					autoWidth:false,
					language: {
						processing: '<i class="fa fa-spinner fa-5x fa-spin" style="font-size:50px;color:black;"></i>'
					},
					filterBy: [1, 4],
					order: [],
					paramData: function (d) {
						var filter = JSON.parse(JSON.stringify(self.filter));
						for (const key in filter) {
							d[key] = filter[key] === false ? 0 : filter[key];
						}
					},
					columns: [
						{
							data: "journal_date",
							render: function (data, type, row, meta) {
								return data ? moment(data).format("DD/MM/YYYY") : '';
							}
						},
						{ data: "no_resi" },
						{ data: "status" },
						{ data: "klaim" },
						{ data: "kurir" },
						{
							data: "hutang_cod",
							render: function (data, type, row, meta) {
								return formatRupiah(data);
							},
							sortable: false
						},
						{
							data: "credit_awal",
							render: function (data, type, row, meta) {
								return formatRupiah(data);
							},
							sortable: false
						},
						{
							data: "total_credit",
							render: function (data, type, row, meta) {
								return formatRupiah(data);
							},
							sortable: false
						},
						{
							data: "total_debit",
							render: function (data, type, row, meta) {
								return formatRupiah(data);
							},
							sortable: false
						},
						{
							data: "sisa_hutang",
							render: function (data, type, row, meta) {
								return formatRupiah(data);
							},
							sortable: false
						}
					],
					rowCallback: function (row, data) {
						if (data.hutang_cod < 0) { $("td:eq(5)", row).addClass("text-danger"); }
						if (data.credit_awal < 0) { $("td:eq(6)", row).addClass("text-danger"); }
						if (data.total_credit < 0) { $("td:eq(7)", row).addClass("text-danger"); }
						if (data.total_debit < 0) { $("td:eq(8)", row).addClass("text-danger"); }
						if (data.sisa_hutang < 0) { $("td:eq(9)", row).addClass("text-danger"); }
					},
					footerCallback:function (row, data, start, end, display) {
						var api = this.api(), data;
						var totalHutang = 
							api
							.column(5, { page: 'current'})
							.data()
							.reduce( function (a, b) {
								var x = parseFloat( a ) || 0;
								var y = parseFloat( b ) || 0;
								return x + y;
							}, 0);

						var grandTotalCredit = api
							.column(7, { page: 'current'})
							.data()
							.reduce( function (a, b) {
								var x = parseFloat( a ) || 0;
								var y = parseFloat( b ) || 0;
								return x + y;
							}, 0 );

						var grandTotalDebit = api
							.column(8, { page: 'current'})
							.data()
							.reduce( function (a, b) {
								var x = parseFloat( a ) || 0;
								var y = parseFloat( b ) || 0;
								return x + y;
							}, 0 );

						var totalSisaHutang = api
							.column(9, { page: 'current'})
							.data()
							.reduce( function (a, b) {
								var x = parseFloat( a ) || 0;
								var y = parseFloat( b ) || 0;
								return x + y;
							}, 0 );

						// Update footer
						$( api.column(5).footer() ).html(formatRupiah(totalHutang));
						$( api.column(7).footer() ).html(formatRupiah(grandTotalCredit));
						$( api.column(8).footer() ).html(formatRupiah(grandTotalDebit));
						$( api.column(9).footer() ).html(formatRupiah(totalSisaHutang));
					},
					initComplete: function(settings, json) {
						self.hideTable = false;
					}
				});
			}
		},
		downloadXlsx: function (e) {
			this.loading = true;
			this.infoDownload = false;

			var filter = JSON.parse(JSON.stringify(this.filter));
				filter.keyword = $("input[name=q]").val() ? $("input[name=q]").val() : null;
				filter.category = $("select[name=category]").val() ? $("select[name=category]").val() : 0;

			var data = {
				"module_code": 'monitoring_hutang_cod',
				"filter": filter,
				"title": 'Monitoring Hutang COD',
				"note": JSON.stringify(filter),
			};

			const self = this;
			authFetch("/accounting/jurnal/request_download", {
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
				},
				body: JSON.stringify(data),
			})
			.then((res) => {
				setTimeout(() => {
					self.loading = false;
				}, 1000);
				if (res){
					self.infoDownload = true;
				}
			});
		}
	},
	mounted() {
		$('.loading-overlay').removeClass('show');

		this.customSwal = Swal.mixin({
			customClass: {
				content: 'p-0',
				title: 'h4 tex-dark',
				input: 'form-control',
				actions: 'd-flex justify-content-between flex-row-reverse',
				confirmButton: 'btn btn-primary col font-weight-bold',
				denyButton: 'btn btn-outline-primary col font-weight-bold',
				cancelButton: 'btn btn-primary w-75 font-weight-bold m-auto',
			},
			buttonsStyling: false
		});
	}
};
</script>